/**
 *  @fileOverview Events module, initalises events from funnelback
 *
 *  @author       Aaron Chapman, edited Chris Hill
 *
 */

function EventModule (axios, SliderModule, Glide, dayjs) {
  /**
  * @description Initialises event instances.
  *
  * @example
  * //
  * @returns {boolean} // null.
  */
  this.init = function () {
    /**
     * Setup promise so that the dependant modules can wait till promise is returned
     */
    return new Promise((resolve, reject) => {
      /**
       * Define vars, desktop and mobile containers to target
       */
      let eventsWide = document.querySelector('[data-events="eventsWide"]')
      let eventsFutureStudents = document.querySelector('[data-events="eventsFutureStudents"]')
      let eventContainer = ''

      /**
       * Check if event div exists
       */
      if (eventsWide !== null || eventsFutureStudents !== null) {
        let url = 'https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-events-json'

        /**
         * Check if on serve or QA
         */
        if (location.href.includes('domain.local') || location.href.includes('wwwqa.ecu.edu.au')) {
          url = 'https://wwwqa.ecu.edu.au/degrees/shared-content/nested-content/funnelback-events-json'
        }

        /**
         * Test which version is on page and assign to var to get params from
         */
        if (eventsFutureStudents !== null) {
          eventContainer = eventsFutureStudents
        } else {
          eventContainer = eventsWide
        }

        /**
         * Only check for filters on desktop version
         */
        let urlVariables = false

        /**
         * Check for data attr modifiers and assign to vars
         */
        let persona = null
        let studyArea = null
        let campus = null
        let discipline = null
        let eventtype = null

        if (typeof eventContainer.dataset.persona !== 'undefined') {
          persona = eventContainer.dataset.persona
        }
        if (typeof eventContainer.dataset.studyarea !== 'undefined') {
          studyArea = eventContainer.dataset.studyarea
        }
        if (typeof eventContainer.dataset.campus !== 'undefined') {
          campus = eventContainer.dataset.campus
        }
        if (typeof eventContainer.dataset.discipline !== 'undefined') {
          discipline = eventContainer.dataset.discipline
        }
        if (typeof eventContainer.dataset.eventtype !== 'undefined') {
          eventtype = eventContainer.dataset.eventtype
        }

        /**
         * Build query string if modifier found
         */
        if (persona != null || studyArea != null || campus != null || discipline != null || eventtype != null) {
          url += '?'
        }

        if (persona != null) {
          if (urlVariables === true) {
            url += '&'
          }
          url += 'persona=' + persona
          urlVariables = true
        }

        if (studyArea != null) {
          if (urlVariables === true) {
            url += '&'
          }
          url += 'studyarea=' + studyArea
          urlVariables = true
        }

        if (campus != null) {
          if (urlVariables === true) {
            url += '&'
          }
          url += 'campus=' + campus
          urlVariables = true
        }

        if (discipline != null) {
          if (urlVariables === true) {
            url += '&'
          }
          url += 'discipline=' + discipline
          urlVariables = true
        }

        if (eventtype != null) {
          if (urlVariables === true) {
            url += '&'
          }
          url += 'eventtype=' + eventtype
          urlVariables = true
        }

        /**
         * Get data from funnelback
         */
        axios.get(url)
          .then(response => {
            if (response.data.results.length > 0) {
              /**
               * Create event slider for the wide screen eg homepage.
               */
              if (eventsWide !== null) {
                removeHidden(eventsWide)
                /**
                 * Build slider HTML
                 */
                eventsWide.innerHTML += `<div class="glide glide--arrowsBeside glide--events" data-js-load="eventSlider" data-items="2" data-hidenumbers="true" data-bullets="true" data-gap="36" data-breakpoints="{ '800': { 'perView': 1 }}">
                                          <div class="glide__arrows" data-glide-el="controls">
                                            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fas fa-chevron-left" title="previous slide"></i></button>
                                            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fas fa-chevron-right" title="next slide"></i></button>
                                          </div>
                                          <div class="glide__track" data-glide-el="track">
                                            <ul class="glide__slides"></ul>
                                            </div>
                                          </div>`
              }
              /**
               * Create event slider for future student pages with `internalNav`
               */
              if (eventsFutureStudents !== null) {
                removeHidden(eventsFutureStudents)
                /**
                 * Build slider HTML
                 */
                eventsFutureStudents.innerHTML += `<div class="glide glide--arrowsBeside glide--events" data-js-load="eventSlider" data-items="1" data-hidenumbers="true" data-bullets="true">
                                          <div class="glide__arrows" data-glide-el="controls">
                                            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fas fa-chevron-left" title="previous slide"></i></button>
                                            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fas fa-chevron-right" title="next slide"></i></button>
                                          </div>
                                          <div class="glide__track" data-glide-el="track">
                                            <ul class="glide__slides"></ul>
                                            </div>
                                          </div>`
              }
              if (eventsWide !== null || eventsFutureStudents !== null) {
                /**
                 * Add a slide for each event
                 */
                // Check if eventsFutureStudents is not null, and select it's list, else select eventsWide lists
                let list = eventsFutureStudents ? eventsFutureStudents.querySelector('.glide__slides') : eventsWide.querySelector('.glide__slides')
                response.data.results.forEach(event => {
                  let date = event.date
                  let dateWrapper = dayjs(date)
                  let dateText = event.multiSession === 'Yes' ? 'Multiple sessions' : dateWrapper.format('h:mma')
                  list.innerHTML += `         <li class="glide__slide">
                                                <div class="events">
                                                  <time datetime="${dateWrapper.format('dddd MMMM D, h:mma')}" class="events__calendar">
                                                    <span class="events__day base__heading base__heading--xs">${dateWrapper.format('ddd')}</span>
                                                    <span class="events__date">${dateWrapper.format('DD')}</span>
                                                    <span class="events__month base__heading base__heading--xs">${dateWrapper.format('MMM')}</span>
                                                  </time>
                                                  <div class="events__container card">
                                                    <h3 class="base__heading base__heading--small"><a href="${event.eventURL}" aria-label="${event.title}">${event.title}</a></h3>
                                                    <div class="eventDetails">
                                                      <i class="eventDetails__icon fas fa-fw fa-clock"></i>${dateText}
                                                    </div>
                                                    <div class="eventDetails">
                                                      <i class="eventDetails__icon fas fa-fw fa-map-marker-alt"></i>${event.venue}
                                                    </div>
                                                  </div>
                                                </div>
                                              </li>`
                })
              }

              /**
               * Init slider when ready
               */
              checkSliderOpacity()

              /**
               * Resolve promise so dependant code can be excecuted
               */
              resolve('Success')
            }
          })
          .catch(error => {
            console.log(error.response)
          })
      } else {
        resolve('No events')
      }

      /**
       * @description Check if ready to initialise sliders.
       *
       * @example
       * //
       * @returns {boolean} // null.
       */
      let checkSliderOpacity = function () {
        let eventPanel

        /**
         * Check if initialising wide event or desktop event
         */
        if (eventsWide !== null) {
          eventPanel = eventsWide
        } else if (eventsFutureStudents !== null) {
          eventPanel = eventsFutureStudents
        } else {
          eventPanel = eventContainer
        }

        if (eventPanel !== null) {
          let eventStyle = window.getComputedStyle(eventPanel)

          if (parseInt(eventStyle.opacity) !== 1) { // We check opacity here as we transiton it, if it's at 1 animation has finished and we can render sliders
            window.requestAnimationFrame(checkSliderOpacity)
          } else {
            let eventSlider = new SliderModule(Glide)
            eventSlider.init('[data-js-load="eventSlider"]')
          }
        }
      }

      /**
       * @description Check for hidden class and remove.
       *
       * @param {Object} target - Node that holds the event slider.
       *
       * @example
       * //
       * @returns {boolean} // null.
       */
      let removeHidden = function (target) {
        let classToRemove
        /**
         * Look for desktop class with hidden and remove
         */
        Array.from(target.classList).forEach(className => {
          if (className.includes('--hidden')) {
            classToRemove = className
          }
        })
        target.classList.remove(classToRemove)
      }
    })
  }
}

module.exports = EventModule
